import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { ShipperNetworkRoutingModule } from "./shipper-network-routing.module";
import { ShipperNetworkComponent } from "./shipper-network.component";
@NgModule({
    declarations: [
        ShipperNetworkComponent
    ],
    imports: [
        CommonModule,
        ShipperNetworkRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
    ]
})

export  class ShipperNetworkModule {}